import { Box, Typography, Grid, Button } from '@mui/material';
import ContentCard from './ContentCard';
import {
  colorLinkGrey,
  colorPrimary,
  colorTextBlack
} from '../../config/theme';
import { useLocation, useNavigate } from 'react-router-dom';
import TourComponent from '../../components/TourGuideComponent';

const ContentSection = ({
  title,
  videoCount,
  documentCount,
  audioCount,
  flashCardsCount,
  videos,
  sectionId,
  tags = [],
  grade,
  contentType = ''
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const subTitle = [
    videoCount > 0 && `${videoCount} ${videoCount > 1 ? 'videos' : 'video'} `,
    documentCount > 0 &&
      `${documentCount} ${documentCount > 1 ? 'documents' : 'document'}`,
    flashCardsCount > 0 &&
      `${flashCardsCount} ${flashCardsCount > 1 ? 'flashcards' : 'flashcard'}`,
    audioCount > 0 && `${audioCount} ${audioCount > 1 ? 'audios' : 'audio'} `
  ]
    .filter(Boolean)
    .join(' | ');

  const handleViewAll = () => {
    console.log('location', location.pathname);
    if (location.pathname == '/content-space/home') {
      navigate('/content-space/home/all', {
        state: {
          sectionId: sectionId,
          sectionName: title,
          subTitle: subTitle,
          tags: tags,
          grade: grade,
          contentType: contentType
        }
      });
    } else if (location.pathname == '/content-space/library') {
      navigate('/content-space/library/all', {
        state: {
          sectionId: sectionId,
          sectionName: title,
          subTitle: subTitle,
          tags: tags
        }
      });
    } else if (location.pathname == '/lite-resources') {
      navigate('/lite-resources/all', {
        state: {
          sectionId: sectionId,
          sectionName: title,
          subTitle: subTitle,
          tags: tags
        }
      });
    }
  };

  return (
    <Box
      sx={{
        marginBottom: 4,
        backgroundColor: '#FFFFFF',
        padding: '16px',
        borderRadius: '8px'
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex' }}>
          <Box>
            <Typography
              variant="h5"
              sx={{ fontSize: '24px', fontWeight: 700, fontFamily: 'Lato' }}
            >
              {title}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: 'Lato',
                marginBottom: 2,
                color: colorLinkGrey
              }}
            >
              {subTitle || ''}
            </Typography>
          </Box>
        </Box>
        <Box>
          <Button
            size="small"
            color="primary"
            variant="outlined"
            sx={{
              borderColor: colorPrimary,
              borderRadius: '8px',
              color: colorTextBlack,
              borderWidth: '2px',
              height: '36px',
              width: '93px',
              textTransform: 'none',
              fontSize: '12px',
              fontWeight: 700,
              alignItems: 'center',
              '&:hover': {
                borderColor: colorPrimary,
                backgroundColor: 'transparent',
                borderRadius: '10px',
                borderWidth: '2px'
              }
            }}
            onClick={() => handleViewAll()}
          >
            View all
          </Button>
        </Box>
      </Box>

      <Grid container spacing={2}>
        {(videos || []).map((video, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Box className="step-content-card">
              <ContentCard video={video} sectionID={sectionId} tags={tags} />
            </Box>
          </Grid>
        ))}
      </Grid>
      {/* <TourComponent /> */}
    </Box>
  );
};

export default ContentSection;
